import { FunctionComponent } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from './Layout';
import BookingProcessStore from './stores/BookingProcessStore';
import RootStore from './stores/RootStore';
import { useBookingReferrer } from './hooks/useBookingReferrer';
import './styles/DMSans.css';

const App: FunctionComponent = () => {
  useBookingReferrer();

  return (
    <BrowserRouter>
      <RootStore>
        <BookingProcessStore>
          <Layout />
        </BookingProcessStore>
      </RootStore>
    </BrowserRouter>
  );
};

export default App;
